/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetGraphDataModel,
  IGetGraphDataRequest,
  IMappers,
  IGetGraphDataResponse,
  IGetGraphDataResponseError,
  TGetGraphDataResponse,
} from './types';

const defaultConfig: TGetGraphDataModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'valuation-b2b',
  pathApi: '/v1/get-graph-data/',
  hostType: 'api',
} as TGetGraphDataModel;

function createGetGraphDataModel(parameters: IGetGraphDataRequest): TGetGraphDataModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetGraphDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetGraphDataRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetGraphData<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetGraphDataOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetGraphDataResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetGraphDataModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetGraphDataResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetGraphDataResponseError);
    }
  }

  return { response, statusCode } as TGetGraphDataResponse;
}

export { defaultConfig, createGetGraphDataModel, fetchGetGraphData };
